import React, { useEffect, useState } from "react";
import styles from "./style.module.css";
import img1 from "../../assets/logo1.svg";
import addLogo from "../../assets/usersDashboard/addIcon.svg";
import addLogoBlack from "../../assets/usersDashboard/analyticsBlack.svg";
import { RxDashboard } from "react-icons/rx";
import { GoPerson } from "react-icons/go";
import { CgNotes } from "react-icons/cg";
import { PiBellRingingBold } from "react-icons/pi";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Router from "../../Components/Router";
import { IoSettingsOutline } from "react-icons/io5";
import { db } from "../../Firebase_config";
import { collection, onSnapshot } from "firebase/firestore";


const Home = () => {
    const navigate = useNavigate()
    const location = useLocation().pathname;
    const userId = JSON.parse(localStorage.getItem("userId"))
    const [outboxArray, setOutbox] = useState([])
    const [inboxArray, setInbox] = useState([])

    const fetchAndSetMessages = async (collectionRef, setState) => {
        try {
            const unsubscribe = onSnapshot(collectionRef, (snapshot) => {
                const messages = snapshot.docs.map(doc => doc.data());

                const sortedMessages = messages.sort(
                    (a, b) =>
                        new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime()
                );

                setState(sortedMessages);
            });

            return unsubscribe;
        } catch (error) {
            console.error("Error fetching messages: ", error);
        }
    };

    const fetchMessages = async (collectionName, userId, setState) => {
        const collectionRef = collection(db, collectionName, userId, "chatUser");
        const unsubscribe = await fetchAndSetMessages(collectionRef, setState);
        return unsubscribe;
    };

    // Usage in your component
    // useEffect(() => {
    //     fetchMessages("outbox", userId, setOutbox);
    //     fetchMessages("inbox", userId, setInbox);


    // }, [userId]);

    function getInboxCount() {
        const unseenInboxMessages = inboxArray.filter(message => !message.receiver);
        const unseenOutboxMessages = outboxArray.filter(message => !message.sender);

        return unseenInboxMessages.length + unseenOutboxMessages.length;
    }


    return (
        <div className={styles.mainContainer}>
            <div className={styles.sideContainer}>
                <img src={img1} alt="" className={styles.image} />

                <div className={styles.listContainer}>
                    <Link to="/">
                        <div id={location === "/" ? styles.active : null}>
                            <RxDashboard className={styles.sideIcons} /> Dashboard
                        </div>
                    </Link>
                    <Link to="/Profile">
                        <div id={location === "/Profile" || location === "/EditProfile" ? styles.active : null}>
                            <GoPerson className={styles.sideIcons} /> Profile
                        </div>
                    </Link>

                    <Link
                        to="/Messages"
                    >
                        <div id={location === "/Messages" || location === "/CreateMessages" || location.startsWith("/Messages/") ? styles.active : null}>
                            <span className={styles.msg}>
                                <CgNotes className={styles.sideIcons} /> Messages
                            </span>
                            {
                                getInboxCount() !== 0 && <span className={styles.numberSpan}>{getInboxCount()}</span>
                            }
                        </div>
                    </Link>


                    <Link
                        to="/Notification"
                    >
                        <div id={location === "/Notification" || location.startsWith("/Notification/") ? styles.active : null}>
                            <PiBellRingingBold className={styles.sideIcons} /> Push Notification
                        </div>
                    </Link>


                    <div className={styles.AddDiv} id={location === "/Partner" || location === "/External" ? styles.active : null}>
                        <div onClick={() => navigate("/Partner")}>
                            {
                                (location === "/Partner" || location === "/External") ? <img src={addLogo} alt="" /> : <img src={addLogoBlack} alt="" />
                            }

                            Advertisement
                        </div>

                    </div>
                    <Link
                        to="/Settings"
                    >
                        <div id={location === "/Settings" || location.startsWith("/colleges/") ? styles.active : null}>
                            <IoSettingsOutline className={styles.sideIcons} /> Settings
                        </div>
                    </Link>


                </div>

            </div>
            <div>
                <Router />
            </div>
        </div >
    );
};

export default Home;
